module.exports = "/assets/data/9c19e4597dc44754bae594f01c7bbdc4-HU1.data.json";